import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2, LogOut } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useLanguage } from "../contexts/LanguageContext";

const TenantEntryBanner = () => {
  const { enteredTenant, exitTenant, isSuperAdmin } = useAuth();
  const { translate } = useLanguage();
  const navigate = useNavigate();

  // Only trust enteredTenant while the user is still a super admin — a
  // stale/leftover value (e.g. from before a role revocation) must not
  // render a false "Managing tenant" signal (RPAA-213 finding #5).
  if (!enteredTenant || !isSuperAdmin()) return null;

  const handleExit = async () => {
    await exitTenant();
    navigate("/tenants");
  };

  return (
    <div
      className="flex-shrink-0 flex items-center justify-between gap-3 px-6"
      style={{
        height: "40px",
        backgroundColor: "var(--color-mint-muted)",
        borderBottom: "1px solid var(--color-mint)",
      }}
    >
      <div className="flex items-center gap-2 min-w-0" style={{ color: "var(--color-text-primary)" }}>
        <Building2 size={16} style={{ color: "var(--color-mint)", flexShrink: 0 }} />
        <span className="text-sm truncate">
          {translate("managingTenant") || "Managing tenant:"}{" "}
          <strong>{enteredTenant.name}</strong>
        </span>
      </div>

      <button
        onClick={handleExit}
        className="flex items-center gap-1.5 px-3 py-1 rounded-lg text-sm font-medium transition-colors hover-surface flex-shrink-0"
        style={{ color: "var(--color-text-primary)" }}
      >
        <LogOut size={14} />
        {translate("exitTenant") || "Exit"}
      </button>
    </div>
  );
};

export default TenantEntryBanner;
